import { throwErrorMessage } from 'dashboard/store/utils/api';
import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import PrivateCommandAPI from '../../api/privateCommand';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

const getters = {
  getPrivateCommands(_state) {
    return _state.records;
  },
  getSortedPrivateCommands(_state) {
    return sortOrder =>
      [..._state.records].sort((a, b) => {
        if (sortOrder === 'asc') {
          return a.short_code.localeCompare(b.short_code);
        }
        return b.short_code.localeCompare(a.short_code);
      });
  },
  getPrivateCommandUIFlags(_state) {
    return _state.uiFlags;
  },
};

const actions = {
  fetchPrivateCommands: async function fetchPrivateCommands(
    { commit },
    { searchKey } = {}
  ) {
    commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, { fetchingList: true });
    try {
      const response = await PrivateCommandAPI.get({ searchKey });
      commit(types.default.SET_PRIVATE_COMMANDS, response.data);
      commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, {
        fetchingList: false,
      });
    } catch (error) {
      commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  createPrivateCommand: async function createPrivateCommand(
    { commit },
    commandObj
  ) {
    commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, { creatingItem: true });
    try {
      const response = await PrivateCommandAPI.create(commandObj);
      commit(types.default.ADD_PRIVATE_COMMAND, response.data);
      commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, {
        creatingItem: false,
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, {
        creatingItem: false,
      });
      return throwErrorMessage(error);
    }
  },

  updatePrivateCommand: async function updatePrivateCommand(
    { commit },
    { id, ...updateObj }
  ) {
    commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, { updatingItem: true });
    try {
      const response = await PrivateCommandAPI.update(id, updateObj);
      commit(types.default.EDIT_PRIVATE_COMMAND, response.data);
      commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, {
        updatingItem: false,
      });
      return response.data;
    } catch (error) {
      commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, {
        updatingItem: false,
      });
      return throwErrorMessage(error);
    }
  },

  deletePrivateCommand: async function deletePrivateCommand({ commit }, id) {
    commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, { deletingItem: true });
    try {
      await PrivateCommandAPI.delete(id);
      commit(types.default.DELETE_PRIVATE_COMMAND, id);
      commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, {
        deletingItem: false,
      });
      return id;
    } catch (error) {
      commit(types.default.SET_PRIVATE_COMMAND_UI_FLAG, {
        deletingItem: false,
      });
      return throwErrorMessage(error);
    }
  },
};

const mutations = {
  [types.default.SET_PRIVATE_COMMAND_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },

  [types.default.SET_PRIVATE_COMMANDS]: MutationHelpers.set,
  [types.default.ADD_PRIVATE_COMMAND]: MutationHelpers.create,
  [types.default.EDIT_PRIVATE_COMMAND]: MutationHelpers.update,
  [types.default.DELETE_PRIVATE_COMMAND]: MutationHelpers.destroy,
};

export default {
  state,
  getters,
  actions,
  mutations,
};
